import { render, staticRenderFns } from "./PgaValutazioneOffertaAltreComponentiDetails.vue?vue&type=template&id=dc3c4654&"
import script from "./PgaValutazioneOffertaAltreComponentiDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaValutazioneOffertaAltreComponentiDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardTitle,VContainer,VDataTable,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc3c4654')) {
      api.createRecord('dc3c4654', component.options)
    } else {
      api.reload('dc3c4654', component.options)
    }
    module.hot.accept("./PgaValutazioneOffertaAltreComponentiDetails.vue?vue&type=template&id=dc3c4654&", function () {
      api.rerender('dc3c4654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/ValutazioneOfferta/Components/PgaValutazioneOffertaAltreComponentiDetails.vue"
export default component.exports